<template>
  <div>
    <!-- <div @click="ej_close()" class="ej" v-if="ej">
      <div class="main">
        <img
          @click="ej_close()"
          class="img1"
          src="../../assets/img/pagess/sky101/close.png"
          alt=""
        />
        <img
          class="img2"
          src="../../assets/img/pagess/sky101/eject.png"
          alt=""
        />
      </div>
    </div> -->
    <!-- <div class="bg" v-if="resss">
      <div class="aaa">
        <div class="card">
          <div class="forms">
            <div class="lis1">
              <span>姓&nbsp;&nbsp;&nbsp;名：</span>
              <div class="ipt">
                <input type="text" placeholder="请输入您的姓名" />
              </div>
            </div>
            <div class="lis1">
              <span>手机号：</span>
              <div class="ipt">
                <input type="text" placeholder="请输入您的手机号" />
              </div>
            </div>
            <div class="lis2">
              <span>验证码：</span>
              <div class="ipt">
                <input type="text" placeholder="验证码" />
              </div>
              <div class="btnss">获取验证码</div>
            </div>
            <el-button type="primary">立即提交</el-button>
          </div>
          <img
            @click="ej_close()"
            class="close"
            src="../../assets/img/pagess/sky101/close (2).png"
            alt=""
          />
        </div>
      </div>
    </div> -->
    <div class="module_1">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btnn"
          src="../../assets/img/pagess/sky101/01.gif"
          alt=""
        />
      </div>
      <!-- <div class="heng">
        <div class="w">
          <img src="../../assets/img/pagess/sky101/module1-3.png" alt="">
          <div class="right">
            更精確 · 更好用 · 更实战
          </div>
        </div>
      </div> -->
      <!-- <div class="w">
        <div class="shu1">
          <img src="../../assets/img/pagess/sky101/module1-4.png" alt="">
          <div class="img2">
            <img src="../../assets/img/pagess/sky101/module1-5.png" alt="">
          </div>

          <div class="img3">
            <img src="../../assets/img/pagess/sky101/module1-6.png" alt="">
          </div>
        </div>
        <div class="shu2">
          <img src="../../assets/img/pagess/sky101/module1-7.png" alt="">
          <img class="img2" src="../../assets/img/pagess/sky101/module1-8.gif" @click="to_xaizai()" alt="">
        </div>
      </div> -->
    </div>
    <div class="module_2">
      <img src="../../assets/img/pagess/sky101/m2-2.png" alt="" />
    </div>
    <div class="module_3" ref="obtain">
      <div class="w">
        <div class="l">
          <div class="li-1">
            <img src="../../assets/img/pagess/sky101/m3-1.png" alt="" />
            <div class="text">
              <span>盘前快速选股</span>
            </div>
          </div>
          <div class="li-2">
            根据沪深将近4000只个股的深度资料进行挖掘，通过现代
            化的数据分析系统，将股票按照超跌板、趋势板、放量板等 方向进行分类
          </div>
          <div class="li-3">
            <img
              src="../../assets/img/pagess/sky101/btns.gif"
              @click="to_xaizai()"
              alt=""
            />
          </div>
          <div class="li-4">直接进入查看并选择</div>
        </div>
        <div class="r">
          <img src="../../assets/img/pagess/sky101/m3-2.png" alt="" />
        </div>
      </div>
    </div>
    <div class="module_4">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/sky101/m4-1.png" alt="" />
        </div>
        <div class="li-2">
          <div class="l">
            <img src="../../assets/img/pagess/sky101/m4-2.png" alt="" />
          </div>
          <div class="r">
            <div class="lis1">
              <img src="../../assets/img/pagess/sky101/m4-3.png" alt="" />
              <div class="text">把握趋势，波段为王</div>
            </div>
            <div class="lis2">
              <span>B信号：</span> B信号提示行情机会，辅助决策
            </div>
            <div class="lis3">
              <span> S信号：</span> S信号提示行情风险，辅助决策
            </div>
            <div class="lis4">
              <img
                src="../../assets/img/pagess/sky101/btns.gif"
                @click="to_xaizai()"
                alt=""
              />
            </div>
            <div class="lis5">根据软件提示，把握个股趋势</div>
          </div>
        </div>
        <div class="li-3">
          以上功能均出自股多多股票软件相关渠道。因市场存在不确定性，产品具有局限性，历史收益不代表未来收益，仅供参考。投资有风险，入市需谨慎
        </div>
      </div>
    </div>
    <div class="module_5">
      <div class="w">
        <div class="li-1">
          <div class="img">
            <img src="../../assets/img/pagess/sky101/m5-1.png" alt="" />
          </div>
        </div>
        <div class="li-2">
          <div class="r">
            <div class="lis1">
              <img src="../../assets/img/pagess/sky101/m5-2.png" alt="" />
              <div class="text">股票信号提示</div>
            </div>
            <div class="lis2"><span>B点：</span>-- 提示机会</div>
            <div class="lis3"><span> S点：</span>-- 提示风险</div>
            <div class="lis6">
              明日的行情涨跌，永远是我们关心的问题。软件给你提供参
              考信号，让你与机会更近一步
            </div>
            <div class="lis4">
              <img
                src="../../assets/img/pagess/sky101/btns.gif"
                @click="to_xaizai()"
                alt=""
              />
            </div>
            <div class="lis5">实时提示个股信号，把握大时机</div>
          </div>
          <div class="l">
            <img src="../../assets/img/pagess/sky101/m5-3.png" alt="" />
          </div>
        </div>
        <div class="li-3">
          以上功能均出自股多多股票软件相关渠道。因市场存在不确定性，产品具有局限性，历史收益不代表未来收益，仅供参考。投资有风险，入市需谨慎
        </div>
      </div>
    </div>
    <div class="module_6">
      <div class="w">
        <div class="text1">—— 投资有风险 入市需谨慎 ——</div>
        <div class="text2">
          从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询
        </div>
        <div class="text2">
          公司：北京天相财富管理顾问有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
            href="https://beian.miit.gov.cn/#/Integrated/index"
          >
            京ICP备16068579号-1</a
          >
        </div>
        <div class="text2">业务资格许可证编号：91110102MA001GJE1N</div>
        <div class="text2">
          <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
          股多多软件版本号：v1.3.1.1288 更新时间：2022年2月
        </div>

        <p
          class="text2 qwer"
          style="text-decoration: underline; cursor: pointer; margin: 5px 0"
        >
          <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
          <span @click="open_yinsi()" style="margin-right: 10px"
            >隐私保护政策</span
          >
          <span @click="open_fuwuxieyi()">软件服务协议</span>
        </p>
        <div class="text2">开发者名称:北京天相财富管理顾问有限公司</div>
        <!-- 010-58299331 -->
      </div>
    </div>
    <div class="box"></div>
    <div class="module_7" v-if="res">
      <div class="w">
        <img
          src="../../assets/img/pagess/sky101/btns.gif"
          @click="to_xaizai()"
          alt=""
        />
      </div>
    </div>
    <!-- <div class="aaa">
      <h4>扫码立即获取最新资讯</h4>
      <img class="qr" src="../../assets/img/pagess/gdd110/0.png" alt="" />
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: false,
      ej: false,
      resss: false,
    };
  },
  mounted() {
    this.clientIp();
    // 滚动条的获取
    window.addEventListener("scroll", this.handleScrollx, true);
  },
  methods: {
    // ej_close() {
    //   this.resss = false;
    // },
    // ej_click() {
    //   this.resss = true;
    // },
    to_xaizai() {
      window.open("https://cdn.juniubang.com/apk/GDD2003.exe");
      this.post_leilei_data();
    },
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          url: window.location.href,
          qhclickid: this.$route.query.qhclickid,
          code: this.$route.query.code,
          type: "360-1",
          event: "SITEDOWNLOAD",
        })
        .then((res) => {});
    },
    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().top < 890) {
        this.res = true;
      } else {
        this.res = false;
      }
    },
    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then((res) => {
          window.localStorage.setItem("_number", res.data);
        });
    },

    open_yinsi() {
      window.open("https://ins.juniubang.com/images/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://ins.juniubang.com/images/应用权限4.7.pdf");
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 9999;

  .aaa {
    width: 100%;
    height: 100vh;
    // background-image: url(../../assets/login/login.jpg);
    background-color: rgba(7, 7, 7, 0.4);
    margin: 0px;
    padding: 0px;
    position: relative;
    .close {
      width: 30px;
      height: 30px;
      position: absolute;
      top: -33px;
      right: -33px;
    }
    .card {
      width: 979px;
      height: 633px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -489px;
      margin-top: -316px;
      // background-color: #fff;
      background: url(../../assets/img/pagess/sky101/ej2.jpg);

      .forms {
        margin: 0 auto;

        width: 300px;
        padding-top: 230px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .lis1 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          span {
            font-size: 16px;
            font-weight: 600;
          }
          .ipt {
            width: 200px;
            height: 40px;
            border: 1px solid #ccc;
            margin-left: 20px;
            input {
              border: none;
              outline: none;
              width: 100%;
              height: 100%;
              font-size: 16px;
            }
          }
        }
        .lis2 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          span {
            font-size: 16px;
            font-weight: 600;
          }
          .ipt {
            margin-left: 20px;
            width: 100px;
            height: 35px;
            background-color: #fff;
            input {
              border: none;
              outline: none;
              width: 100%;
              height: 100%;
            }
          }
          .btnss {
            line-height: 35px;
            border-radius: 5px;
            width: 80px;
            height: 35px;
            font-size: 10px;
            text-align: center;
            margin-left: 20px;
            font-weight: 600;
            background-color: #409eff;
            color: #fff;
          }
        }
      }
    }
  }
}
// .aaa {
//   width: 200px;
//   height: 250px;
//   background-color: rgba(140, 124, 124, 0.3);
//   position: fixed;
//   left: 10px;
//   top: 300px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;

//   .qr {
//     width: 130px;
//     height: 130px;
//   }
// }
.ej {
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100vh;
  background-color: rgba(16, 15, 15, 0.3);
  .main {
    width: 1000px;
    height: 800px;
    padding-left: 300px;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .img1 {
      margin-left: 50px;
    }
    .img2 {
      width: 979px;
      height: 633px;
    }
  }
}
.module_1 {
  width: 100%;
  height: 917px;
  background: url(../../assets/img/pagess/sky101/1-1.png) no-repeat;
  background-size: 100% 100%;
  .w {
    width: 100px;
    margin: 0 auto;
    position: relative;
    .btnn {
      position: absolute;
      top: 700px;
      left: 50px;
    }
  }
}
.module_2 {
  width: 100%;
  height: 186px;
  background: url(../../assets/img/pagess/sky101/m2-1.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.module_3 {
  width: 100%;
  height: 564px;
  background: url(../../assets/img/pagess/sky101/m3.png) no-repeat;
  background-size: 100% 100%;
  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    .l {
      height: 100%;
      display: flex;
      flex-direction: column;
      .li-1 {
        padding-top: 125px;
        display: flex;
        align-items: flex-start;
        .text {
          padding: 0 0 13px 31px;
          span {
            width: 301px;
            font-size: 46px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #bc1102;
          }
        }
      }
      .li-2 {
        margin-top: 36px;
        width: 552px;
        font-size: 19px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
      }
      .li-3 {
        margin-top: 46px;
        padding-left: 78px;
        img {
          width: 328px;
          height: 95px;
        }
      }
      .li-4 {
        margin-top: 26px;
        width: 273px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #bc1102;
        line-height: 21px;
        padding-left: 137px;
      }
    }
    .r {
      width: 565px;
      height: 406px;
      margin-left: 86px;
    }
  }
}
.module_4 {
  width: 100%;
  height: 746px;
  background: url(../../assets/img/pagess/sky101/m4.png) no-repeat;
  background-size: 100% 100%;
  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    .li-1 {
      padding-top: 64px;
      margin-bottom: 46px;
    }
    .li-2 {
      width: 100%;
      height: 406px;
      display: flex;
      .l {
        margin-right: 72px;
      }
      .r {
        .lis1 {
          display: flex;
          align-items: center;
          margin-bottom: 49px;
          .text {
            margin-left: 31px;
            height: 45px;
            font-size: 46px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #bc1102;
            line-height: 40px;
          }
        }
        .lis2 {
          margin-bottom: 30px;
        }
        .lis2,
        .lis3 {
          font-size: 20px;
          color: #333333;
          font-family: Microsoft YaHei;
        }
        .lis2 span,
        .lis3 span {
          font-size: 25px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #bc1102;
          line-height: 26px;
        }
        .lis4 {
          padding-left: 100px;
          margin-top: 46px;
          margin-bottom: 25px;
          img {
            width: 328px;
            height: 95px;
          }
        }
        .lis5 {
          padding-left: 125px;
          margin-top: 26px;
          width: 273px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #bc1102;
          line-height: 21px;
        }
      }
    }
    .li-3 {
      margin-top: 79px;
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #989192;
      line-height: 21px;
    }
  }
}
.module_5 {
  width: 100%;
  height: 740px;
  background: url(../../assets/img/pagess/sky101/m5.png) no-repeat;
  background-size: 100% 100%;
  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    .li-1 {
      padding-top: 70px;
      margin-bottom: 42px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: end;
      .img {
        padding-right: 25px;
      }
    }
    .li-2 {
      width: 100%;
      height: 406px;
      display: flex;
      .l {
        margin-left: 89px;
      }
      .r {
        .lis1 {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .text {
            margin-left: 31px;
            height: 45px;
            font-size: 46px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #bc1102;
            line-height: 40px;
          }
        }
        .lis2 {
          margin-bottom: 10px;
        }
        .lis2,
        .lis3 {
          padding-left: 107px;
          font-size: 20px;
          color: #333333;
          font-family: Microsoft YaHei;
        }
        .lis2 span,
        .lis3 span {
          font-size: 25px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #bc1102;
          line-height: 26px;
        }
        .lis4 {
          padding-left: 100px;
          margin: 26px 0;
          img {
            width: 328px;
            height: 95px;
          }
        }
        .lis6 {
          margin-top: 31px;
          margin-bottom: 26px;
          width: 551px;
          height: 46px;
          font-size: 19px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 26px;
        }
        .lis5 {
          padding-left: 106px;
          width: 327px;
          height: 20px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #bc1102;
          line-height: 21px;
        }
      }
    }
    .li-3 {
      margin-top: 79px;
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #989192;
      line-height: 21px;
    }
  }
}
.module_6 {
  width: 100%;
  height: 180 px;
  background: url(../../assets/img/pagess/sky101/m6.png) no-repeat;
  background-size: 100% 100%;
  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #989192;
    line-height: 21px;
    .text1 {
      padding-top: 24px;
      margin-bottom: 20px;
    }
    .qwer span:hover {
      color: #fff;
    }
  }
}
.module_7 {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 162px;
  background: url(../../assets/img/pagess/sky101/m7.png) no-repeat;
  background-size: 100% 100%;
  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    img {
      position: absolute;
      top: 15px;
      right: 0;
    }
  }
}
.box {
  width: 100%;
  height: 162px;
}
</style>     


// WEBPACK FOOTER //
// src/pages/pagess/gdd101.vue